import Model from './Model';

export default class Expense extends Model {
  resource() {
    return 'daily-allowances';
  }
}
